module.exports = __webpack_public_path__ + "static/media/NeuzeitGroBla.bc8be373.ttf";